import { isNil } from './is-nil';


/**
 * Renames the property of an object.
 *
 * @param valueObject The object which needs to be changed.
 * @param oldName The property to rename.
 * @param newName The new property name.
 */
export function renameObjectProperty(valueObject: any, oldName: string, newName: string): void {
  if (!isNil(valueObject, oldName)) {
    valueObject[newName] = valueObject[oldName];
    delete valueObject[oldName];
  }
}
